import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styles from './PersonalSettings.module.scss'
import classnames from 'classnames'
import PrivateWealthEmailLink from 'components/Shared/PrivateWealthEmailLink/PrivateWealthEmailLink'

const PersonalSettings = (props) => {
  const {
    user
  } = props

  const parseDateOfBirth = (stringDate) => {
    if (!stringDate) {
      return ''
    }

    const splitDate = stringDate.split('-')

    return `${splitDate[1]}/${splitDate[2]}/${splitDate[0]}`
  }

  const primaryAddressFields = [
    'billingCity',
    'billingState',
    'billingPostalCode',
    'billingStreet',
    'billingCountry'
  ]

  const noPrimaryAddressFields = !(primaryAddressFields.map(f => user[f]).every(v => !!v))

  const buildBillingAddress = (user) => {
    const  {
      billingCity,
      billingState,
      billingPostalCode
    } = user

    const addComma = billingCity ? ',' : ''

    return `${billingCity ? billingCity : ''}${billingState ? `${addComma} ${billingState}` : ''} ${billingPostalCode ? billingPostalCode : ''}`
  }

  const { personHomePhone, personMobilePhone } = user
  const noDataAvailable = fieldName => `No ${fieldName} Available`

  const primaryAddress = (
    <Fragment>
      <div className={styles.addressText} data-test-id="billingStreet">
        {user.billingStreet}
      </div>
      <div className={styles.addressText} data-test-id="billingState">
        {buildBillingAddress(user)}
      </div>
      <div className={styles.addressText} data-test-id="billingCountry">
        {user.billingCountry}
      </div>
    </Fragment>
  )
  return (
    <div className={styles.container}>
      <p className={styles.header}>
         If you need to change your personal details,
         please <PrivateWealthEmailLink message="contact your team" />.
      </p>
      <div className={styles.infoRow}>
        <div className={styles.infoColumn}>
          <label>name</label>
          <div className={styles.text} data-test-id="fullName">{user.fullName}</div>
        </div>
        <div className={styles.infoColumn}>
          <label>date of birth</label>
          {user.personBirthdate ?
            <div className={styles.text} data-test-id="personBirthdate">{parseDateOfBirth(user.personBirthdate)}</div> :
            <div className={styles.noData}>{noDataAvailable('Date of Birth')}</div>
          }
        </div>
      </div>
      <div className={styles.infoRow}>
        <div className={styles.addressColumn} >
          <label>Primary Address</label>
          {noPrimaryAddressFields && <div className={styles.noData}>{noDataAvailable('Primary Address')}</div>}
          {!noPrimaryAddressFields && <div>{primaryAddress}</div>}
        </div>
      </div>
      <div className={classnames(styles.infoRow, styles.desktopPhoneRow)}>
        <div className={styles.infoColumn}>
          <label>mobile phone number</label>
          {personMobilePhone  ?
            <div className={styles.text} data-test-id="personMobilePhone">
              {personMobilePhone}
            </div> :
            <div className={styles.noData} data-test-id="personMobilePhone-noData">
              {noDataAvailable('Mobile Phone Number')}
            </div>}
        </div>
        <div className={styles.infoColumn}>
          <label>home phone number</label>
          {personHomePhone ?
            <div className={styles.text} data-test-id="personHomePhone">
              {personHomePhone}
            </div> :
            <div className={styles.noData} data-test-id="personMobilePhone-noData">
              {noDataAvailable('Home Phone Number')}
            </div>}
        </div>
      </div>
      <div className={classnames(styles.infoRow, styles.mobilePhoneRow)}>
        <div className={styles.infoColumn}>
          <label>phone number</label>
          {personMobilePhone ?
            <div className={styles.text} data-test-id="personMobilePhone">
              {personMobilePhone}
              <div className={styles.mobileLabel}>mobile</div>
            </div> :
            <div className={styles.noData} data-test-id="personMobilePhone-noData">
              {noDataAvailable('Mobile Phone Number')}
            </div>}
          {personHomePhone ?
            <div className={classnames(styles.text)} data-test-id="personHomePhone">
              {personHomePhone}
              <div className={styles.mobileLabel}>home</div>
            </div> :
            <div className={styles.noData} data-test-id="personHomePhone-noData">
              {noDataAvailable('Home Phone Number')}
            </div>}
        </div>
      </div>
    </div>
  )
}

PersonalSettings.defaultProps = {
  user: {}
}

PersonalSettings.propTypes = {
  user: PropTypes.object
}

export default PersonalSettings



// WEBPACK FOOTER //
// ./src/components/Client/PersonalSettings/PersonalSettings.jsx